import { render, staticRenderFns } from "./ModalGerenciarEnvio.vue?vue&type=template&id=1b8f4f08&scoped=true"
import script from "./ModalGerenciarEnvio.vue?vue&type=script&lang=js"
export * from "./ModalGerenciarEnvio.vue?vue&type=script&lang=js"
import style0 from "./ModalGerenciarEnvio.vue?vue&type=style&index=0&id=1b8f4f08&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f4f08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b8f4f08')) {
      api.createRecord('1b8f4f08', component.options)
    } else {
      api.reload('1b8f4f08', component.options)
    }
    module.hot.accept("./ModalGerenciarEnvio.vue?vue&type=template&id=1b8f4f08&scoped=true", function () {
      api.rerender('1b8f4f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modals/ModalGerenciarEnvio.vue"
export default component.exports